const COPY = ' ©';

function Copyright() {
  const d = new Date();
  return (
    <>
      {COPY} {d.getFullYear()}
    </>
  );
}

export default Copyright;
